import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { memo } from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";

interface WidgetProps {
  name: string;
  title: string;
  value: string;
  valueColor: string;
  nameColor: string;
  showDollar?: boolean;
  redirectLink?: string;
}

function Widget({ name, title, value, nameColor, valueColor, showDollar, redirectLink }: WidgetProps) {
  return (
    <Paper className="flex flex-col flex-auto shadow-sm rounded-xl overflow-hidden">
      <div className="flex items-center justify-between px-2 pt-2">
        <Typography
          className="px-3 text-lg font-medium tracking-tight leading-6 truncate"
          color="text.secondary"
        >
          {title}
        </Typography>
      </div>
      <div className="text-center my-4">
        <Typography
          className={clsx(
            "text-7xl sm:text-8xl font-bold tracking-tight leading-none",
            valueColor
          )}
        >
          {showDollar && '$'}{value}
        </Typography>
        <Typography
          className={clsx("text-lg font-medium mt-1", nameColor)}
          component={redirectLink ? Link : 'span'}
          to={redirectLink}
        >
          {name}
        </Typography>
      </div>
    </Paper>
  );
}

export default memo(Widget);
